import classNames from 'classnames';
import { Flex } from 'antd';
import type { FC, ReactNode } from 'react';
import styles from '../../sidebar-primary-navigation.module.scss';

interface NavigationSectionProps {
  variant?: 'main' | 'secondary';
  children: ReactNode;
}

export const NavigationSection: FC<NavigationSectionProps> = ({
  variant = 'main',
  children,
}) => (
  <Flex
    vertical
    className={classNames(styles.sidebarPrimaryNav__section, {
      [styles['sidebarPrimaryNav__section--secondary']]: variant === 'secondary',
    })}
  >
    {children}
  </Flex>
);
